import { SET_DASHBOARD_DATA, SET_DASHBOARD_LOADING, SET_ANIO_ACTIVO, SET_SUCURSAL_ACTIVA, SET_MES_ACTIVO, SET_SECTOR_ACTIVO, SET_METRICA_ACTIVA, SET_PRODUCTOS_ACTIVOS, SET_PRODUCTOS_DISPONIBLES, SET_VER_POR_ACTIVO, SET_SEMANA_ACTIVA, SET_FECHA_DESDE, SET_FECHA_HASTA } from './ventasDashboardReducer';

export const setDashboardLoading = (isLoading) => ({
    type: SET_DASHBOARD_LOADING,
    payload: isLoading
});

export const setAnioActivo = (anio) => ({
    type: SET_ANIO_ACTIVO,
    payload: anio
});

export const setSucursalActiva = (sucursalId) => ({
    type: SET_SUCURSAL_ACTIVA,
    payload: sucursalId
});

export const setMesActivo = (mes) => ({
    type: SET_MES_ACTIVO,
    payload: mes
});

export const setSectorActivo = (sector) => ({
    type: SET_SECTOR_ACTIVO,
    payload: sector
});

export const setMetricaActiva = (metrica) => ({
    type: SET_METRICA_ACTIVA,
    payload: metrica
});

export const setProductosActivos = (productos) => ({
    type: SET_PRODUCTOS_ACTIVOS,
    payload: productos
});

export const setProductosDisponibles = (productos) => ({
    type: SET_PRODUCTOS_DISPONIBLES,
    payload: productos
});

export const setVerPorActivo = (verPor) => ({
    type: SET_VER_POR_ACTIVO,
    payload: verPor
});

export const setSemanaActiva = (semana) => ({
    type: SET_SEMANA_ACTIVA,
    payload: semana
});

export const setFechaDesde = (fecha) => ({
    type: SET_FECHA_DESDE,
    payload: fecha
});

export const setFechaHasta = (fecha) => ({
    type: SET_FECHA_HASTA,
    payload: fecha
});

export const setDashboardData = (cacheKey, data) => ({
    type: SET_DASHBOARD_DATA,
    payload: { cacheKey, data }
});

export const fetchDashboardData = async (anio, sucursalId, verPor, mes, semana, fechaDesde, fechaHasta, sector, productos, dispatch, getState) => {
    const state = getState();
    
    const prodsStr = productos && productos.length > 0 ? productos.join(',') : '';
    const cacheKey = `${anio}_${sucursalId || 'ALL'}_${verPor}_${mes || 'ALL'}_${semana || 'ALL'}_${fechaDesde || 'ALL'}_${fechaHasta || 'ALL'}_${sector || 'ALL'}_${prodsStr || 'ALL'}`;
    
    dispatch(setAnioActivo(anio));
    dispatch(setSucursalActiva(sucursalId));
    dispatch(setVerPorActivo(verPor));
    dispatch(setMesActivo(mes));
    dispatch(setSemanaActiva(semana));
    dispatch(setFechaDesde(fechaDesde));
    dispatch(setFechaHasta(fechaHasta));
    dispatch(setSectorActivo(sector));
    dispatch(setProductosActivos(productos || []));

    // Si aún no tenemos los productos disponibles para el select, los cargamos 1 vez
    if (!state.ventasDashboard.productosDisponibles || state.ventasDashboard.productosDisponibles.length === 0) {
        try {
            const pRes = await fetch('/api/dashboard-ventas/productos-disponibles').then(res => res.json());
            if (pRes.success) dispatch(setProductosDisponibles(pRes.data));
        } catch(e) { console.error("Error loading products"); }
    }

    if (state.ventasDashboard && state.ventasDashboard.cachePorAnio[cacheKey]) {
        console.log(`Cargando datos desde caché para ${cacheKey}`);
        return; 
    }

    dispatch(setDashboardLoading(true));
    
    try {
        let qs = `?anio=${anio}`;
        if (sucursalId) qs += `&sucursal_id=${sucursalId}`;
        if (verPor) qs += `&ver_por=${verPor}`;
        if (mes && verPor === 'mes') qs += `&mes=${mes}`;
        if (semana && verPor === 'semana') qs += `&semana=${semana}`;
        if (fechaDesde && verPor === 'dia') qs += `&fecha_desde=${fechaDesde}`;
        if (fechaHasta && verPor === 'dia') qs += `&fecha_hasta=${fechaHasta}`;
        if (sector) qs += `&sector=${encodeURIComponent(sector)}`;
        if (prodsStr) qs += `&productos=${encodeURIComponent(prodsStr)}`;
        
        const [kpisRes, mensualRes, sectorRes, topRes, tablaRes, metasRes] = await Promise.all([
            fetch(`/api/dashboard-ventas/kpis${qs}`).then(res => res.json()),
            fetch(`/api/dashboard-ventas/comparativo-mensual${qs}`).then(res => res.json()),
            fetch(`/api/dashboard-ventas/ventas-por-sector${qs}`).then(res => res.json()),
            fetch(`/api/dashboard-ventas/top-productos${qs}`).then(res => res.json()),
            fetch(`/api/dashboard-ventas/tabla-comparativa${qs}`).then(res => res.json()),
            fetch(`/api/dashboard-ventas/metas-productos${qs}`).then(res => res.json())
        ]);

        const dashboardData = {
            kpis: kpisRes.data,
            comparativoMensual: mensualRes.data,
            ventasPorSector: sectorRes.data,
            topProductos: topRes.data,
            tablaComparativa: tablaRes.data,
            metasProductos: metasRes.data
        };

        dispatch(setDashboardData(cacheKey, dashboardData));
    } catch (error) {
        console.error("Error fetching dashboard data:", error);
        dispatch(setDashboardLoading(false));
    }
};
